import { IAccountPageLang } from '../../../types/lang'

export const accountPageLang: IAccountPageLang = {
	account_page: {
		notification_deleted_accounts_count: '{{cnt}} accounts',
		notification_deleted_accounts_title: 'are deleted',
		btn_add_new: 'Add New',
		btn_delete_multiple_items: 'Delete {{cnt}} items'
	}
}